let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gf4mF")).then(() => parcelRequire('9GdMy'));